import React from 'react';
import moment from 'moment';
import { twMerge } from 'tailwind-merge';
import { Message } from 'flow/types/Chats';
import { TypedMap } from 'flow/types/TypedMap';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import Icon from 'flow/components/ui-components/Icon';
import FailedMessageContextMenu from 'flow/components/context-menus/FailedMessageContextMenu';

interface Props {
    message: TypedMap<Message>;
    sessionKey: ChatSessionKey;
    videoDark: boolean;
}

/**
 * The column at the end of a message row: the time it was sent, the SMS
 * marker when it also went out as a text message, and the retry menu when
 * it failed to send.
 */
const ChatMessageMeta = ({ message, sessionKey, videoDark }: Props) => {
    const sent = message.get('sent');

    return (
        <div className="flex w-12 flex-col items-end justify-start gap-y-1">
            <time
                className={twMerge(
                    'text-xs/4',
                    videoDark ? 'text-gray-400' : 'text-gray-500',
                )}
                dateTime={sent}
            >
                {moment(sent).format('HH:mm')}
            </time>
            <div className="flex items-center">
                {message.get('alsoAsSMS') ? (
                    <Icon
                        iconKey="sms"
                        className={
                            videoDark ? 'text-gray-400' : 'text-gray-500'
                        }
                    />
                ) : null}
                {message.get('failed', false) && (
                    <FailedMessageContextMenu
                        message={message}
                        chatSessionKey={sessionKey}
                    />
                )}
            </div>
        </div>
    );
};

export default ChatMessageMeta;
